import { defineStore } from 'pinia';
import { defaultLocale, Locales } from '@/plugins/i18n';
import { moment } from '@/utils/datetime';
import { UiState } from '@/types';

export const useUiStore = defineStore('ui', {
    state: (): UiState => ({
        isLoading: false,
        locale: defaultLocale,
        isLevelLocked: false,
    }),
    getters: {
        getIsLoading: (state): boolean => state.isLoading,
    },
    actions: {
        setIsLoading(isLoading: boolean) {
            this.isLoading = isLoading;
        },

        setLocale(locale: string) {
            const storedLocale = localStorage.getItem('locale');

            locale = locale || storedLocale || Locales.ptBR;

            const normalizedLocale =
                locale === Locales.enUS || locale === 'en-US' ? Locales.enUS : Locales.ptBR;
            moment.locale(normalizedLocale === Locales.enUS ? 'en' : 'pt-br');

            localStorage.setItem('locale', normalizedLocale);
            this.locale = normalizedLocale;
        },

        setIsLevelLocked(isLevelLocked: boolean) {
            this.isLevelLocked = isLevelLocked;
        },
    },
});
